import React, { Component } from 'react';
import { createPortal } from 'react-dom';
import http from '../modules/api';

import SelectBoxV2 from '../modules/common/SelectBoxV2';
import CheckBox from '../modules/common/CheckBox';

import SaveDialogV2 from '../modules/dialogs/SaveDialogV2';
import WarningDialog from "../modules/dialogs/WarningDialog";
import RoboMDAICopywriterModal from './component/RoboMDAICopywriterModal';

const COPYWRITER_SETTING_TUTORIAL_EVENT = "instagram-tutorial:copywriter-setting-action";

const COPYWRITER_SELECTED_CONTENT_STORAGE_KEY =
  "instagram_copywriter_selected_content";
const COPYWRITER_SELECTED_CONTENT_APPLY_PARAM =
  "apply_copywriter_content";

const COPYWRITER_AUTOMATION_PATHS = Object.freeze({
  AI_IMAGE: "/shop/instagram/InstagramCreateAiImageAutomation",
  PRODUCT: "/shop/instagram/InstagramCreateProductAutomation",
});

const FACEBOOK_APP_ID = '780456611206591';
const BASEDOMAIN = document.domain.indexOf("127.0.0.1") >= 0 ? 'https://127.0.0.1:8092' : "https://robomd.io";
const REDIRECT_URI = BASEDOMAIN + '/rest/shop/instagram/callbackForRefleshParent';
const SCOPES = [
  'pages_show_list',
  'business_management',
  'instagram_basic',
  'instagram_content_publish',
  'instagram_manage_insights',
  'public_profile'
].join(',');

class InstagramCopywriterSetting extends Component {
  constructor(props) {
    super(props);

    this.automationMenuRef = React.createRef();
    this.editDialogRef = React.createRef();

    this.state = {
      preset_seq: props.editPresetId || new URLSearchParams(window.location.search).get('preset_seq'),
      isEditPresetLoading: Boolean(props.editPresetId),
      isEditAccountLoading: Boolean(props.editPresetId),
      editPresetLoadError: '',
      presetTitle: '',
      // 제목을 직접 입력하지 않을 때 사용할 자동 제목 (플레이스홀더)
      suggestedPresetTitle: '카피라이터_년도월일_번호',
      isDataLearningOn: true,
      industry: '',
      target: '',
      language: 'ko',
      objective: '',
      ctaPosition: 'bottom',
      ctaText: '',
      extraPrompt: '',
      learningData: 'multi', // multi, text, image
      
      // 다중 생성 카드 체크 상태
      cardsChecked: {
        'ref-basic': true,
        'ref-myfeed': false,
        'ref-custom': false,
      },
      
      // 내부 아이템 선택 상태
      selectedInnerItems: {
        'ref-basic': 0,
        'ref-custom': 0,
      },

      // 커스텀 뱅크 관련 상태
      customTextInput: '',
      customItems: [
        // '매일 아침 10분 더 자게 해주는 26도 헤어만의 시그니처 단발펌! ⏰ 드라이기 하나면 미용실 다녀온 퀄리티 그대로 연출 가능해요.'
      ],

      // 계정 연동
      add_account_list: [],
      account_list: [],
      account_list_v2: [],
      default_ig_access_seq: "",
      selected_ig_access_seq: "",
      selectedAccount: null,
      accountConnected: false,

      feedCaptions: [],
      selectedLearnedFeedCaptions: [],
      selectedLearnedFeedCaptionsCnt: 0,

      isRunModalOpen: false,
      runPresetSeq: null,
      runModalKey: 0,
      isSavingPreset: false,
      automationMenuOpen: false,

      // 경고 다이얼로그
      warning_dialog_show_state: false,
      warning_dialog_content: '',
      warning_dialog_button_list: [],
    };
  }

  componentDidMount() {
    this.editDialogRef.current?.focus();
    window.addEventListener(COPYWRITER_SETTING_TUTORIAL_EVENT, this.handleCopywriterSettingTutorialAction);
    if (this.state.preset_seq) {
      this.loadPresetData();
    } else {
      this.loadSuggestedPresetTitle();
      this.loadReferenceBankList();
    }
    this.loadInstagramAccountList();

    window.addEventListener("message", this.handleInstagramAccountMessage);
    document.addEventListener("mousedown", this.handleDocumentMouseDown);
  }

  componentWillUnmount() {
    window.removeEventListener(COPYWRITER_SETTING_TUTORIAL_EVENT, this.handleCopywriterSettingTutorialAction);
    window.removeEventListener("message", this.handleInstagramAccountMessage);
    document.removeEventListener("mousedown", this.handleDocumentMouseDown);
  }

  handleCopywriterSettingTutorialAction = (event) => {
    const action = event?.detail?.action;

    const ensureTutorialSnapshot = () => {
      if (this.copywriterSettingTutorialSnapshot) return;
      this.copywriterSettingTutorialSnapshot = {
        cardsChecked: { ...(this.state.cardsChecked || {}) },
      };
    };

    const showVoice = (voiceKey) => {
      ensureTutorialSnapshot();
      this.setState((prev) => ({
        cardsChecked: {
          ...(prev.cardsChecked || {}),
          'ref-basic': true,
          'ref-myfeed': voiceKey === 'ref-myfeed',
          'ref-custom': voiceKey === 'ref-custom',
        },
      }));
    };

    if (action === "SHOW_VOICE_BASIC") {
      showVoice('ref-basic');
      return;
    }

    if (action === "SHOW_VOICE_MYFEED") {
      showVoice('ref-myfeed');
      return;
    }

    if (action === "SHOW_VOICE_CUSTOM") {
      showVoice('ref-custom');
      return;
    }

    if (action === "RESTORE") {
      if (!this.copywriterSettingTutorialSnapshot) return;
      const snapshot = this.copywriterSettingTutorialSnapshot;
      this.copywriterSettingTutorialSnapshot = null;
      this.setState({ cardsChecked: { ...(snapshot.cardsChecked || {}), 'ref-basic': true } });
    }
  };

  handleDocumentMouseDown = (event) => {
    const menuElement = this.automationMenuRef.current;

    if (
      this.state.automationMenuOpen &&
      menuElement &&
      !menuElement.contains(event.target)
    ) {
      this.setState({ automationMenuOpen: false });
    }
  };

  // 서버가 제안하는 다음 자동 제목을 조회한다. 조회만으로 번호를 예약하지는 않는다.
  loadSuggestedPresetTitle = async () => {
    try {
      const response = await http.get('/rest/shop/instagram/copywriter/preset/next-title');
      const data = response?.data || {};
      if (data.status === 'success' && data.preset_title) {
        this.setState({ suggestedPresetTitle: data.preset_title });
      } else {
        this.setState({ suggestedPresetTitle: '카피라이터_년도월일_번호' });
      }
    } catch (error) {
      console.error('자동 제목 조회 실패:', error);
      this.setState({ suggestedPresetTitle: '카피라이터_년도월일_번호' });
    }
  };

  // 기존 원본 소스의 포커스 이벤트 핸들러 복구
  handleFocus = (e) => {
    if (this.props.editPresetId) return;
    if (e.target.id === 'presetTitle' && this.state.presetTitle === 'A 스타일 (여름 이벤트 피드 본문용)') {
      this.setState({ presetTitle: '' });
    }
    // 제목 플레이스홀더는 포커스 중에도 유지해 미입력 저장 제목을 확인할 수 있게 한다.
    if (e.target.id !== 'presetTitle') e.target.placeholder = '';
  };

  handleBlur = (e) => {
    const dataPlaceholder = e.target.getAttribute('data-placeholder');
    if (dataPlaceholder) {
      e.target.placeholder = dataPlaceholder;
    }
  };

  // 상태 관리 통합 핸들러
  handleStateChange = (key, value) => {
    this.setState({ [key]: value });
  }

  closeWarningDialog = () => {
    this.setState({ warning_dialog_show_state: false });
  };

  showWarningDialog = (content) => {
    this.setState({
      warning_dialog_show_state: true,
      warning_dialog_content: content,
      warning_dialog_button_list: [{
        title: "확인",
        type: "1",
        event_method: this.closeWarningDialog,
      }],
    });
  };

  toggleDataLearning = () => {
    // 비노출 정책: 기존 핸들러를 유지하되 학습 기능은 항상 활성화.
    this.setState({ isDataLearningOn: true, learningData: 'multi' });
  };

  handleCardCheck = (cardId, isChecked) => {
    this.setState((prevState) => ({
      cardsChecked: {
        ...prevState.cardsChecked,
        [cardId]: isChecked,
      },
    }));
  };

  handleInnerItemSelect = (cardId, index) => {
    this.setState((prevState) => ({
      selectedInnerItems: {
        ...prevState.selectedInnerItems,
        [cardId]: index,
      },
    }));
  };

  handleAddCustomRef = () => {
    const { customTextInput } = this.state;
    const text = (customTextInput || '').trim();

    if (!text) {
      this.showWarningDialog("레퍼런스로 사용할 피드 문구를 입력해주세요.");
      return;
    }

    http.post('/rest/shop/instagram/aiCopywriter/referenceBank/insert', {
      custom_reference_text: text
    })
      .then((response) => {
        const result = response?.data;

        if (result?.result === 'success') {
          this.setState({ customTextInput: '' }, () => {
            this.loadReferenceBankList();
          });
        } else {
          alert(result?.message || '커스텀 뱅크 저장에 실패했습니다.');
        }
      })
      .catch((error) => {
        console.error('커스텀 뱅크 추가 중 오류 발생:', error);
        alert('커스텀 뱅크 저장 중 오류가 발생했습니다.');
      });
  };

  handleDeleteCustomRef = (e, index) => {
    e.stopPropagation();

    const target = (this.state.customItems || [])[index];
    if (!target) return;

    // 아직 저장 안 된 임시 항목 방어
    if (!target.custom_reference_seq) {
      this.setState((prev) => {
        const newItems = [...(prev.customItems || [])];
        newItems.splice(index, 1);

        const reordered = newItems.map((item, idx) => ({
          ...item,
          sort_order: idx,
        }));

        let selectedIndex = prev.selectedInnerItems['ref-custom'] || 0;

        if (selectedIndex === index) {
          selectedIndex = reordered.length > 0 ? Math.max(0, index - 1) : 0;
        } else if (selectedIndex > index) {
          selectedIndex -= 1;
        }

        return {
          customItems: reordered,
          selectedInnerItems: {
            ...prev.selectedInnerItems,
            'ref-custom': selectedIndex,
          },
        };
      });
      return;
    }

    http.post('/rest/shop/instagram/aiCopywriter/referenceBank/delete', {
      custom_reference_seq: target.custom_reference_seq
    })
      .then((response) => {
        const result = response?.data;

        if (result?.result === 'success') {
          this.loadReferenceBankList();
        } else {
          alert(result?.message || '커스텀 뱅크 삭제에 실패했습니다.');
        }
      })
      .catch((error) => {
        console.error('커스텀 뱅크 삭제 중 오류 발생:', error);
        alert('커스텀 뱅크 삭제 중 오류가 발생했습니다.');
      });
  };

  loadReferenceBankList = (selectedReferenceSeqList = []) => {
    return http.post('/rest/shop/instagram/aiCopywriter/referenceBank/list', {})
      .then((response) => {
        const list = Array.isArray(response?.data?.list) ? response.data.list : [];

        this.setState((prevState) => {
          const prevCustomItems = Array.isArray(prevState.customItems) ? prevState.customItems : [];
          const prevSelectedInnerItems = prevState.selectedInnerItems || {};
          const prevSelectedCustomIndex = Number(prevSelectedInnerItems['ref-custom'] ?? 0);

          const prevSelectedCustomItem =
            prevCustomItems[prevSelectedCustomIndex] &&
            prevCustomItems[prevSelectedCustomIndex].custom_reference_seq
              ? prevCustomItems[prevSelectedCustomIndex]
              : null;

          const prevSelectedCustomReferenceSeq = prevSelectedCustomItem
            ? String(prevSelectedCustomItem.custom_reference_seq)
            : '';

          const selectedReferenceSeqSet = new Set(
            (selectedReferenceSeqList || []).map(v => String(v))
          );

          const nextCustomItems = list.map((item, index) => ({
            custom_reference_seq: item.custom_reference_seq,
            custom_reference_text: item.custom_reference_text || '',
            selected_yn: 'N',
            sort_order: index,
          }));

          let nextSelectedCustomIndex = -1;

          // 1. 프리셋 조회에서 내려온 selected_yn = 'Y' 항목을 우선 반영
          if (selectedReferenceSeqSet.size > 0) {
            nextSelectedCustomIndex = nextCustomItems.findIndex(
              (item) => selectedReferenceSeqSet.has(String(item.custom_reference_seq))
            );
          }

          // 2. 프리셋 선택값이 없을 때만 화면에서 이미 선택 중이던 항목 유지
          if (nextSelectedCustomIndex < 0 && prevSelectedCustomReferenceSeq) {
            nextSelectedCustomIndex = nextCustomItems.findIndex(
              (item) => String(item.custom_reference_seq) === prevSelectedCustomReferenceSeq
            );
          }

          // 3. 그래도 없으면 0으로
          if (nextSelectedCustomIndex < 0) {
            nextSelectedCustomIndex = 0;
          }

          const finalCustomItems = nextCustomItems.map((item, index) => ({
            ...item,
            selected_yn: index === nextSelectedCustomIndex ? 'Y' : 'N',
          }));

          return {
            customItems: finalCustomItems,
            selectedInnerItems: {
              ...prevSelectedInnerItems,
              'ref-custom': nextSelectedCustomIndex,
            },
          };
        });
      })
      .catch((error) => {
        console.error('커스텀 레퍼런스 뱅크 조회 중 오류 발생:', error);
      });
  };

  loadPresetData = () => {
    http.get('/rest/shop/instagram/copywriter/preset/info?preset_seq=' + this.state.preset_seq)
      .then((response) => {
        if (response?.data?.status === 'success' && response?.data?.result) {
          const data = response.data.result;
          const learnedCaptionList = data.learned_caption_list || [];
          const customReferenceList = Array.isArray(data.custom_reference_list)
            ? data.custom_reference_list
            : [];

          const selectedCustomIndex = customReferenceList.findIndex(
            item => String(item.selected_yn || '').toUpperCase() === 'Y'
          );

          const selectedReferenceSeqList = customReferenceList
          .filter(item => String(item.selected_yn || '').toUpperCase() === 'Y')
          .map(item => item.custom_reference_seq);

          this.setState({
            presetTitle: data.preset_title || '',
            industry: data.industry || '',
            target: data.target || '',
            language: data.language_code || 'ko',
            objective: data.objective || '',

            cardsChecked: {
              'ref-basic': true, // 숨김 기본 적용 (기존 설정에서도 항상 켜짐)
              'ref-myfeed': data.use_myfeed_voice == 1 || data.use_myfeed_voice === true || data.use_myfeed_voice === 'Y',
              'ref-custom': data.use_custom_voice == 1 || data.use_custom_voice === true || data.use_custom_voice === 'Y',
            },

            selectedInnerItems: {
              'ref-basic': data.basic_voice_index || 0,
              'ref-custom': selectedCustomIndex >= 0 ? selectedCustomIndex : 0,
            },

            extraPrompt: data.extra_prompt || '',
            isDataLearningOn: true, // 숨김 기본 적용

            learningData: 'multi', // 숨김 기본 매핑
            ctaPosition: data.call_to_action_position || 'bottom',
            ctaText: data.call_to_action_text || '',
            customItems: customReferenceList,
            selected_ig_access_seq: data.instagram_access_token_seq || "",
            selectedLearnedFeedCaptions: learnedCaptionList,
            selectedLearnedFeedCaptionsCnt: learnedCaptionList.length,
          }, () => {
            const referenceBankRequest = this.loadReferenceBankList(selectedReferenceSeqList);
            if (this.props.editPresetId) {
              referenceBankRequest.then(() => this.setState({ isEditPresetLoading: false }));
            }
            
            const shouldLoadMyFeed =
              this.state.cardsChecked['ref-myfeed'] && this.getActiveIgSeq();

            if (shouldLoadMyFeed) {
              this.fetchAllInstagramMedia(false, this.getActiveIgSeq());
            }
          });
        } else if (this.props.editPresetId) {
          this.setState({
            isEditPresetLoading: false,
            editPresetLoadError: '존재하지 않는 설정입니다.',
          });
        } else {
          alert("존재하지 않는 설정입니다.");
        }
      })
      .catch((error) => {
        console.error('설정 조회 중 오류 발생:', error);
        if (this.props.editPresetId) {
          this.setState({
            isEditPresetLoading: false,
            editPresetLoadError: '카피라이터 설정을 불러오지 못했습니다.',
          });
        }
      });
  };

  getActiveIgSeq = () => {
    return this.state.selected_ig_access_seq || this.state.default_ig_access_seq || "";
  };

  validateBeforeSave = () => {
    const {
      presetTitle,
      cardsChecked,
      customItems,
      selectedInnerItems,
      accountConnected,
      selected_ig_access_seq,
      default_ig_access_seq,
      selectedLearnedFeedCaptions,
      isDataLearningOn,
      learningData,
      extraPrompt,
      ctaText,
      objective,
      industry,
      target,
    } = this.state;

    const title = (presetTitle || '').trim();
    const industryText = (industry || '').trim();
    const targetText = (target || '').trim();
    const objectiveText = (objective || '').trim();

    const selectedVoiceCount = Object.values(cardsChecked || {}).filter(Boolean).length;
    const selectedIgSeq = this.getActiveIgSeq();
    const customList = Array.isArray(customItems) ? customItems : [];
    const selectedMyFeedList = Array.isArray(selectedLearnedFeedCaptions) ? selectedLearnedFeedCaptions : [];
    const customSelectedIndex = Number(selectedInnerItems?.['ref-custom'] ?? 0);

    if (!industryText) {
      this.showWarningDialog("업종 특성을 입력해주세요.");
      return false;
    }

    if (!targetText) {
      this.showWarningDialog("주요 타겟 고객을 입력해주세요.");
      return false;
    }

    if (!objectiveText) {
      this.showWarningDialog("생성 목적을 입력해주세요.");
      return false;
    }

    if (title.length > 100) {
      this.showWarningDialog("AI 카피라이터 제목은 100자 이하로 입력해주세요.");
      return false;
    }

    if (industryText.length > 200) {
      this.showWarningDialog("업종 특성은 200자 이하로 입력해주세요.");
      return false;
    }

    if (targetText.length > 200) {
      this.showWarningDialog("주요 타겟 고객은 200자 이하로 입력해주세요.");
      return false;
    }

    // if (selectedVoiceCount === 0) {
    //   alert("브랜드 보이스를 최소 1개 이상 선택해주세요.");
    //   return false;
    // }

    if (cardsChecked['ref-myfeed']) {
      if (!accountConnected) {
        this.showWarningDialog("내 기존 피드 AI 보이스를 사용하려면 인스타그램 계정 연동이 필요합니다.");
        return false;
      }

      if (!selectedIgSeq) {
        this.showWarningDialog("학습할 인스타그램 계정을 선택해주세요.");
        return false;
      }

      if (selectedMyFeedList.length === 0) {
        this.showWarningDialog("내 기존 피드 AI 보이스를 사용하려면 학습 기준 게시물을 1개 선택해주세요.");
        return false;
      }
    }

    if (cardsChecked['ref-custom']) {
      if (customList.length === 0) {
        this.showWarningDialog("커스텀 뱅크 AI 보이스를 사용하려면 레퍼런스 문구를 1개 이상 추가해주세요.");
        return false;
      }

      if (customSelectedIndex < 0 || customSelectedIndex >= customList.length) {
        this.showWarningDialog("커스텀 뱅크에서 학습 기준 문구를 1개 선택해주세요.");
        return false;
      }

      const hasEmptyCustomText = customList.some(
        (item) => !String(item?.custom_reference_text || '').trim()
      );

      if (hasEmptyCustomText) {
        this.showWarningDialog("비어 있는 커스텀 레퍼런스 문구가 있습니다.");
        return false;
      }
    }

    if (isDataLearningOn && !['multi', 'text', 'image'].includes(learningData)) {
      this.showWarningDialog("데이터 학습 방식을 선택해주세요.");
      return false;
    }

    if (objectiveText.length > 1000) {
      this.showWarningDialog("생성 목적은 1000자 이하로 입력해주세요.");
      return false;
    }

    if ((extraPrompt || '').length > 2000) {
      this.showWarningDialog("AI 추가 명령 프롬프트는 2000자 이하로 입력해주세요.");
      return false;
    }

    if ((ctaText || '').length > 300) {
      this.showWarningDialog("CTA 문구는 300자 이하로 입력해주세요.");
      return false;
    }

    return true;
  };

  buildPresetSavePayload = () => {
    const {
      presetTitle, cardsChecked, selectedInnerItems,
      customItems, industry, target, language, objective,
      ctaPosition, ctaText, extraPrompt
    } = this.state;

    const customReferenceList = (customItems || []).map((item, index) => ({
      custom_reference_seq: item.custom_reference_seq,
      selected_yn: index === selectedInnerItems['ref-custom'] ? 'Y' : 'N'
    }));

    return {
      preset_seq: this.state.preset_seq,
      // 빈 제목은 서버에서 날짜별 자동 제목으로 확정한다.
      preset_title: (presetTitle || '').trim(),
      industry: industry || '',
      target: target || '',
      language_code: language || 'ko',
      objective: objective || '',
      use_basic_voice: 1, // 화면에서 숨긴 기본 AI 브랜드 보이스는 항상 사용
      basic_voice_index: selectedInnerItems['ref-basic'] || 0,
      use_myfeed_voice: cardsChecked['ref-myfeed'] ? 1 : 0,
      use_custom_voice: cardsChecked['ref-custom'] ? 1 : 0,
      custom_voice_index: selectedInnerItems['ref-custom'] || 0,
      extra_prompt: extraPrompt || '',
      is_data_learning_on: 1, // 화면에서 숨긴 학습 설정은 항상 켜짐
      learning_data_type: 'multi', // 멀티모달 기본 선택
      call_to_action_position: ctaPosition || 'bottom',
      call_to_action_text: ctaText || '',
      custom_reference_list: customReferenceList,
      selectedLearnedFeedCaptions: this.state.selectedLearnedFeedCaptions,
      instagram_access_token_seq: this.getActiveIgSeq(),
    };
  };

  savePreset = async (runAfterSave = false, automationType = "") => {
    const { isSavingPreset, isEditPresetLoading, isEditAccountLoading, editPresetLoadError } = this.state;
    const { editPresetId, onPresetSaved } = this.props;
    if (isSavingPreset || isEditPresetLoading || isEditAccountLoading || editPresetLoadError) return false;
    if (editPresetId) {
      this.setState({ save_dialog_show_state: false, warning_dialog_show_state: false });
    }
    if (!this.validateBeforeSave()) return false;

    const payload = this.buildPresetSavePayload();
    const invalidCustomReference = (payload.custom_reference_list || []).some(
      item => !item.custom_reference_seq
    );

    if (this.state.cardsChecked['ref-custom'] && invalidCustomReference) {
      this.showWarningDialog("저장되지 않은 커스텀 뱅크 문구가 있습니다.");
      return false;
    }

    this.setState({
      isSavingPreset: true,
      save_dialog_show_state: true,
      save_dialog_content: "저장중 입니다.",
      save_dialog_button_list: [{ title: "확인", type: "1", display_yn: "N" }],
    });

    try {
      const response = await http.post('/rest/shop/instagram/copywriter/preset', payload);
      if (response?.data?.status !== 'success') {
        throw new Error(response?.data?.message || '저장에 실패했습니다.');
      }

      const nextSeq = response?.data?.preset_seq || this.state.preset_seq;
      if (!nextSeq) throw new Error('저장된 AI 카피라이터 번호를 확인하지 못했습니다.');
      // 제목을 입력하지 않았다면 서버가 확정한 자동 제목으로 화면 상태를 동기화한다.
      const savedPresetTitle = response?.data?.preset_title || payload.preset_title;

      if (editPresetId) {
        this.setState({
          preset_seq: nextSeq,
          presetTitle: savedPresetTitle,
          isSavingPreset: false,
          save_dialog_show_state: false,
        }, onPresetSaved);
        return true;
      }

      if (window.opener) {
        window.opener.postMessage(
          { type: "copywriter_setting_saved", result: true, preset_seq: nextSeq },
          window.location.origin
        );
      }

      const url = new URL(window.location.href);
      url.searchParams.set("preset_seq", nextSeq);
      window.history.replaceState({}, "", url);

      // 저장 후 비운 제목을 다시 편집할 때 플레이스홀더에 이전 번호가 남지 않도록 갱신한다.
      if (!automationType) this.loadSuggestedPresetTitle();

      if (automationType) {
        const targetPath = COPYWRITER_AUTOMATION_PATHS[automationType];

        if (!targetPath) {
          throw new Error("이동할 자동화 설정 화면을 확인하지 못했습니다.");
        }

        await new Promise((resolve) => {
          this.setState({
            preset_seq: nextSeq,
            presetTitle: savedPresetTitle,
            automationMenuOpen: false,
            isSavingPreset: false,
            save_dialog_show_state: false,
          }, resolve);
        });

        window.location.href =
          `${targetPath}?copywriter_preset_seq=${encodeURIComponent(nextSeq)}`;

        return true;
      }

      if (runAfterSave) {
        await new Promise((resolve) => {
          this.setState((prev) => ({
            preset_seq: nextSeq,
            presetTitle: savedPresetTitle,
            runPresetSeq: nextSeq,
            isRunModalOpen: true,
            runModalKey: prev.runModalKey + 1,
            isSavingPreset: false,
            save_dialog_show_state: false,
          }), resolve);
        });
      } else {
        this.setState({
          preset_seq: nextSeq,
          presetTitle: savedPresetTitle,
          isSavingPreset: false,
          save_dialog_show_state: true,
          save_dialog_content: "저장되었습니다.",
          save_dialog_button_list: [{
            title: "확인",
            type: "1",
            event_method: () => this.setState({ save_dialog_show_state: false })
          }],
        });
      }

      return true;
    } catch (error) {
      console.error('설정 저장 중 오류 발생:', error);
      this.setState({
        isSavingPreset: false,
        save_dialog_show_state: true,
        save_dialog_content: error?.message || "저장에 실패했습니다.",
        save_dialog_button_list: [{
          title: "확인",
          type: "1",
          event_method: () => this.setState({ save_dialog_show_state: false })
        }],
      });
      return false;
    }
  };

  handleSavePreset = () => this.savePreset(false);

  handleEditDialogKeyDown = (event) => {
    if (event.key === 'Escape' && !event.defaultPrevented) {
      event.stopPropagation();
      if (!this.state.isSavingPreset) this.props.onCancelEdit();
      return;
    }

    if (event.key !== 'Tab' || event.defaultPrevented) return;

    const focusable = Array.from(event.currentTarget.querySelectorAll(
      'button, input, textarea, select, a[href], [tabindex]'
    )).filter((element) => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!first) return;

    if (event.shiftKey && (event.target === first || event.target === event.currentTarget)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && event.target === last) {
      event.preventDefault();
      first.focus();
    }
  };

  handleSaveAndRunPreset = () => this.savePreset(true);

  handleSaveAndGoAutomation = (automationType) => {
    this.setState({ automationMenuOpen: false }, () => {
      this.savePreset(false, automationType);
    });
  };

  handleSelectedContentRegister = (
    selectedText,
    selectedRecommendations = [],
    copywriterContext = {}
  ) => {
    const content = Array.isArray(selectedText)
      ? selectedText
          .map((item) => String(item || "").trim())
          .filter(Boolean)
          .join("\n\n")
      : String(selectedText || "").trim();

    if (!content) {
      this.showWarningDialog("콘텐츠에 사용할 문구를 선택해주세요.");
      return false;
    }

    const popupPresetSeq = String(
      copywriterContext.copywriter_preset_seq || ""
    ).trim();

    const fallbackPresetSeq = String(
      this.state.runPresetSeq || this.state.preset_seq || ""
    ).trim();

    const copywriterPresetSeq =
      popupPresetSeq || fallbackPresetSeq || null;

    const recommendationHistorySeq = (selectedRecommendations || [])
      .map((item) => item?.copywriter_history_seq)
      .find(Boolean);

    const transferPayload = {
      caption: content,
      copywriter_preset_seq: copywriterPresetSeq,
      copywriter_preset_title:
        copywriterContext.copywriter_preset_title ||
        this.state.presetTitle ||
        null,
      copywriter_history_seq:
        copywriterContext.copywriter_history_seq ||
        recommendationHistorySeq ||
        null,
    };

    sessionStorage.setItem(
      COPYWRITER_SELECTED_CONTENT_STORAGE_KEY,
      JSON.stringify(transferPayload)
    );

    window.location.href =
      `/shop/instagram/InstagramCreatePost?${COPYWRITER_SELECTED_CONTENT_APPLY_PARAM}=Y`;

    return true;
  };

  closeRunModal = () => {
    this.setState({ isRunModalOpen: false });
  };

  /* 내 피드 학습 */
  loadInstagramAccountList = (token_id) => {
    const url = token_id
      ? "/rest/shop/instagram/profile/list?token_id=" + token_id
      : "/rest/shop/instagram/profile/list";

    http.get(url)
      .then((res) => {
        const list = Array.isArray(res?.data?.list) ? res.data.list : [];
        const account_list = this.buildIgAccountOptions(list);
        const account_list_v2 = this.buildIgAccountOptionsV2(list);
        const defaultSeq = this.buildIgDefaultAccount(list) || "";
        const selectedSeq = this.state.selected_ig_access_seq || defaultSeq || "";

        const targetAcc =
          (account_list_v2 || []).find(acc => String(acc.value) === String(selectedSeq)) || null;

        this.setState({
          add_account_list: list,
          account_list,
          account_list_v2,
          default_ig_access_seq: defaultSeq,
          accountConnected: list.length > 0,
          selectedAccount: targetAcc,
          selected_ig_access_seq: selectedSeq,
          isEditAccountLoading: false,
        }, () => {
          const igSeq = this.getActiveIgSeq();
          if (igSeq) {
            this.fetchAllInstagramMedia(!!token_id, igSeq);
          }
        });
      })
      .catch((error) => {
        console.error(error);
        if (this.props.editPresetId) this.setState({ isEditAccountLoading: false });
      });
  };

  buildIgAccountOptions = (apiPayload) => {
    const src = (apiPayload && (apiPayload.list || apiPayload)) || [];
    const opts = [];

    src.forEach((fb) => {
      const fbName = fb.facebook_username || "(이름 없음)";
      const igList = fb.instagram_account_list || [];

      igList.forEach((ig) => {
        const v = String(ig.instagram_access_token_seq ?? "");
        if (!v) return;

        const uname = ig.username ? `@${ig.username}` : "(계정명 없음)";
        opts.push({
          value: v,
          title: `${fbName} / ${uname}`,
        });
      });
    });

    return opts;
  };

  buildIgAccountOptionsV2 = (apiPayload) => {
    const src = (apiPayload && (apiPayload.list || apiPayload)) || [];
    const opts = [];

    src.forEach((fb) => {
      const igList = fb.instagram_account_list || [];

      igList.forEach((ig) => {
        const v = String(ig.instagram_access_token_seq ?? "");
        if (!v) return;

        const uname = ig.username ? `${ig.username}` : "(계정명 없음)";
        opts.push({
          value: v,
          title: `${uname}`,
          profile_picture_url: ig.profile_picture_url || null,
        });
      });
    });

    return opts;
  };

  buildIgDefaultAccount = (apiPayload) => {
    const src = (apiPayload && (apiPayload.list || apiPayload)) || [];

    for (const fb of src) {
      const igList = fb.instagram_account_list || [];

      const found = igList.find((ig) => {
        const v = String(ig.instagram_access_token_seq ?? "");
        return v && ig.default_yn === "Y";
      });

      if (found) {
        return String(found.instagram_access_token_seq);
      } else if (igList.length > 0) {
        return String(igList[0].instagram_access_token_seq ?? "");
      }
    }

    return "";
  };

  handleConnectAccount = () => {
    const authUrl =
      `https://www.facebook.com/v24.0/dialog/oauth?` +
      `client_id=${FACEBOOK_APP_ID}` +
      `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
      `&scope=${SCOPES}` +
      `&response_type=code`;

    window.open(authUrl, "_blank", "width=600,height=800");
  };

  onChangeAccount = (text, value) => {
    const targetAcc =
      (this.state.account_list_v2 || []).find(acc => String(acc.value) === String(value)) || null;

    this.setState(
      {
        selected_ig_access_seq: value,
        selectedAccount: targetAcc,
        selectedLearnedFeedCaptions: [],
        selectedLearnedFeedCaptionsCnt: 0,
      },
      () => {
        const igSeq = this.getActiveIgSeq();
        if (igSeq) {
          this.fetchAllInstagramMedia(true, igSeq);
        }
      }
    );
  };

  fetchAllInstagramMedia = (is_init = false, instagram_access_token_seq, pageLimit = 100, maxItems = 5000) => {
    if (!instagram_access_token_seq) {
      return;
    }

    http.get(`/rest/shop/instagram/${instagram_access_token_seq}/media/all`, {
      params: {
        pageLimit,
        maxItems,
      },
    })
      .then((response) => {
        const res = response.data;

        if (res && res.status === "success") {
          const feedCaptions = (res.data.data || [])
            .filter((item) => this.cleanCaption(item.caption))
            .map((item) => ({
              instagram_media_id: item.id,
              caption: this.cleanCaption(item.caption),
              timestamp: item.timestamp,
            }));

          this.setState({
            mediaList: res.data.data || [],
            feedCaptions,
            selectedLearnedFeedCaptions: is_init ? [] : this.state.selectedLearnedFeedCaptions,
            selectedLearnedFeedCaptionsCnt: is_init ? 0 : this.state.selectedLearnedFeedCaptionsCnt,
          });
        }
      })
      .catch((error) => {
        console.error("Instagram 미디어 조회 오류:", error);
      });
  };

  cleanCaption = (text) => {
    if (!text) return "";

    let caption = text;

    // 문장 시작 부분에 붙어있는 해시태그 제거
    // 예: "#여행 #카페 오늘 날씨 좋다" → "오늘 날씨 좋다"
    caption = caption.replace(/^\s*(#[A-Za-z0-9가-힣_]+\s*)+/gm, "");

    // 본문 중간 또는 끝에 있는 @멘션 제거
    // 예: "오늘 @friend 와 카페" → "오늘 와 카페"
    caption = caption.replace(/(^|\s)@[A-Za-z0-9._]+/g, "$1");

    // 문장 뒤에 붙은 해시태그 제거 (본문은 유지)
    // 예: "오늘 날씨 좋다 #여행 #힐링" → "오늘 날씨 좋다"
    caption = caption.replace(/([^\n#]+?)(\s*#[A-Za-z0-9가-힣_]+)+\s*$/gm, "$1");

    // 해시태그만 있는 줄 제거
    // 예: "#여행 #힐링 #카페" → ""
    caption = caption.replace(/^\s*(#[A-Za-z0-9가-힣_]+\s*)+$/gm, "");

    // 연속된 줄바꿈을 하나로 정리하고 앞뒤 공백 제거
    // 예: "\n\n\n안녕하세요\n\n" → "안녕하세요"
    caption = caption.replace(/\n{2,}/g, "\n").trim();

    return caption;
  };

  selectLearnedFeed = (id, caption) => {
    const copy = [...(this.state.selectedLearnedFeedCaptions || [])];
    const index = copy.findIndex((obj) => obj.instagram_media_id == id);

    if (index !== -1) {
      copy.splice(index, 1);
    } else {
      copy.push({
        instagram_access_token_seq: this.getActiveIgSeq(),
        instagram_media_id: id,
        caption,
      });
    }

    this.setState({
      selectedLearnedFeedCaptions: copy,
      selectedLearnedFeedCaptionsCnt: copy.length,
    });
  };

  selectLearnedFeedOnlyOne = (id, caption) => {
    const current = this.state.selectedLearnedFeedCaptions || [];
    const alreadySelected = current.some(obj => obj.instagram_media_id == id);

    let next = [];

    if (!alreadySelected) {
      next = [{
        instagram_access_token_seq: this.getActiveIgSeq(),
        instagram_media_id: id,
        caption
      }];
    }

    this.setState({
      selectedLearnedFeedCaptions: next,
      selectedLearnedFeedCaptionsCnt: next.length,
    });
  };

  handleInstagramAccountMessage = (e) => {
    // 필요하면 origin 체크 추가
    // if (e.origin !== "https://robomd.io" && e.origin !== "https://127.0.0.1:8092") return;

    if (e.data && e.data.type === "refreshInstagramAccount") {
      const token_id = e.data.token_id;

      if (token_id) {
        this.loadInstagramAccountList(token_id);
      } else {
        this.loadInstagramAccountList();
      }

      return;
    }
  };

  formatDate = (timestamp) => {
    if (!timestamp) return "";

    const date = new Date(timestamp);

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");

    return `${yyyy}.${mm}.${dd}`;
  };

  render() {
    const {
      presetTitle, cardsChecked, selectedInnerItems,
      customTextInput, customItems, industry, target, language, objective,
      ctaPosition, ctaText, extraPrompt,
      isSavingPreset, isEditPresetLoading, isEditAccountLoading, editPresetLoadError,
    } = this.state;
    const isEditingInModal = Boolean(this.props.editPresetId);
    const wrapperId = isEditingInModal ? 'copywriter-edit-wrapper' : 'page-wrapper';
    const formId = (id) => isEditingInModal ? `copywriter-edit-${id}` : id;
    const isEditorReady = !isEditPresetLoading && !editPresetLoadError;
    const editorMessage = this.state.save_dialog_show_state && !isSavingPreset
      ? this.state.save_dialog_content
      : this.state.warning_dialog_show_state && this.state.warning_dialog_content;
    const ContentContainer = isEditingInModal ? 'div' : 'main';

    const languageList = [
      { name: '한국어', code: 'ko' }, { name: '영어', code: 'en' },
      { name: '독일어', code: 'de' }, { name: '중국어(간체)', code: 'zh-cn' },
      { name: '중국어(번체)', code: 'zh-tw' }, { name: '일본어', code: 'ja' },
      { name: '베트남어', code: 'vi' }, { name: '프랑스어', code: 'fr' },
      { name: '스페인어', code: 'es' }, { name: '힌디어', code: 'hi' },
      { name: '아랍어', code: 'ar' }, { name: '벵골어', code: 'bn' },
      { name: '러시아어', code: 'ru' }, { name: '포르투갈어', code: 'pt' }
    ];

    const content = (
      <>
        {/* page-wrapper는 공통 레이아웃과 SelectBoxV2의 기준 요소이므로 유지 */}
        <div
          className={isEditingInModal ? 'robo-md-copywriter-setting-page copywriter-edit-panel' : 'main-wrapper robo-md-copywriter-setting-page'}
          id={wrapperId}
          ref={isEditingInModal ? this.editDialogRef : undefined}
          role={isEditingInModal ? 'dialog' : undefined}
          aria-modal={isEditingInModal ? true : undefined}
          aria-label={isEditingInModal ? 'AI 카피라이터 수정' : undefined}
          tabIndex={isEditingInModal ? -1 : undefined}
          onKeyDown={isEditingInModal ? this.handleEditDialogKeyDown : undefined}
          style={{ height: isEditingInModal ? undefined : '100vh', display: 'flex', flexDirection: 'column', backgroundColor: '#f6f8fb', fontFamily: "'Noto Sans KR', sans-serif" }}
        >
          <div className="robo-md-copywriter">
            <style>{`
              @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;500;600;700&display=swap');
              .robo-md-copywriter-setting-page {
                --copy-accent: #00e2e6;
                --copy-ink: #111827;
                --copy-muted: #6b7280;
                --copy-border: #e5e7eb;
                padding-top: 72px !important;
                max-width: 100% !important;
                min-width: 0;
                box-sizing: border-box;
                overflow: hidden;
              }
              .copywriter-edit-overlay {
                position: fixed;
                inset: 0;
                z-index: 13030;
                display: flex;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                padding: 12px;
                background: rgba(10, 26, 47, .42);
              }
              .robo-md-copywriter-setting-page.copywriter-edit-panel {
                width: min(1080px, 100%);
                height: min(1025px, 100%);
                padding: 0 !important;
                border-radius: 12px;
                box-shadow: 0 12px 36px rgba(10, 26, 47, .28);
              }
              .robo-md-copywriter .copywriter-edit-footer {
                flex-shrink: 0;
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                justify-content: flex-end;
                gap: 8px 12px;
                padding: 12px 20px;
                border-top: 1px solid var(--copy-border);
                background: #fff;
              }
              .robo-md-copywriter .copywriter-edit-error { flex: 1 1 240px; margin: 0; color: #b91c1c; font-size: 14px; }
              /* AI 카피라이터 제목 옆 느낌표 툴팁 아래로 표시 */
              .robo-md-copywriter .copywriter-page-header .info-icon:hover::after {
                  top: 130%;
                  bottom: auto;
              }
              .robo-md-copywriter,
              .robo-md-copywriter * { box-sizing: border-box; font-family: 'Noto Sans KR', sans-serif; word-break: keep-all; }
              .robo-md-copywriter { flex: 1; min-height: 0; display: flex; flex-direction: column; overflow: hidden; background: #f6f8fb; color: var(--copy-ink); line-height: 1.5; }
              .robo-md-copywriter button, .robo-md-copywriter input, .robo-md-copywriter textarea { font: inherit; }
              /* page-wrapper 내부 헤더: 메인 콘텐츠와 동일한 페이지 영역에서 표시 */
              .robo-md-copywriter .copywriter-page-header { display: flex; justify-content: space-between; align-items: center; gap: 16px; flex-shrink: 0; padding: 20px 32px; background: rgba(255,255,255,.95); backdrop-filter: blur(4px); border-bottom: 1px solid #e5e7eb; }
              .robo-md-copywriter .header-title-group { display: flex; align-items: center; gap: 12px; flex: 1; min-width: 0; }
              .robo-md-copywriter .header-accent-bar { width: 4px; height: 24px; border-radius: 2px; background: var(--copy-accent); flex-shrink: 0; }
              .robo-md-copywriter .header-title-inline { display: flex; align-items: center; min-width: 0; }
              .robo-md-copywriter .page-title { font-size: 20px; font-weight: 700; color: var(--copy-ink); line-height: 1.4; margin: 0; white-space: nowrap; }
              .robo-md-copywriter .header-actions { display: flex; gap: 10px; align-items: center; flex-shrink: 0; }
              .robo-md-copywriter .btn-header { padding: 10px 24px; min-height: 41px; border-radius: 6px; font-size: 14px; font-weight: 600; border: none; cursor: pointer; transition: background .2s; white-space: nowrap; line-height: 1.5; }
              .robo-md-copywriter .btn-header:disabled { opacity: .55; cursor: not-allowed; }
              .robo-md-copywriter .btn-gray { background: #f3f4f6; color: var(--copy-ink); }
              .robo-md-copywriter .btn-gray:hover:not(:disabled) { background: #e5e7eb; }
              .robo-md-copywriter .btn-cyan { background: #00e2e6; color: #111827; padding: 10px 32px; }
              .robo-md-copywriter .btn-cyan:hover:not(:disabled) { background: #00cfd4; }
              .robo-md-copywriter .btn-outline { background: #fff; border: 1px solid #d1d5db; color: #4b5563; }
              .robo-md-copywriter .btn-outline:hover:not(:disabled) { background: #f9fafb; border-color: var(--copy-accent); }
              .robo-md-copywriter .btn-small { min-height: 32px; padding: 6px 16px; font-size: 13px; }
              .robo-md-copywriter .automation-menu-wrap { position: relative; }
              .robo-md-copywriter .automation-menu { position: absolute; top: calc(100% + 8px); right: 0; z-index: 1200; min-width: 220px; padding: 6px; background: #fff; border: 1px solid #e5e7eb; border-radius: 8px; box-shadow: 0 12px 30px rgba(10,26,47,.16); }
              .robo-md-copywriter .automation-menu-item { display: block; width: 100%; min-height: 42px; padding: 10px 12px; border: none; border-radius: 6px; background: transparent; color: var(--copy-ink); text-align: left; font-size: 14px; font-weight: 600; cursor: pointer; }
              .robo-md-copywriter .automation-menu-item:hover { background: #f0fdfe; }
              .robo-md-copywriter .content-container { flex: 1; min-height: 0; overflow-y: auto; overflow-x: hidden; padding: 32px 40px; width: 100%; display: flex; flex-direction: column; gap: 24px; }
              .copywriter-edit-panel .robo-md-copywriter .content-container { padding: 28px 20px; }
              .robo-md-copywriter .content-inner { width: 100%; max-width: 960px; margin: 0 auto; display: flex; flex-direction: column; gap: 24px; }
              .robo-md-copywriter .title-lang-row { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 24px; width: 100%; }
              .robo-md-copywriter .title-group { display: flex; flex: 1; flex-direction: column; gap: 8px; min-width: 200px; }
              .robo-md-copywriter .title-label { font-size: 14px; font-weight: 600; color: #4b5563; }
              .robo-md-copywriter .req { color: #ef4444; margin-left: 4px; font-weight: 700; }
              .robo-md-copywriter .preset-name-input { width: 100%; border: none; border-bottom: 1px solid #d1d5db; padding: 0 0 8px; font-size: 18px; font-weight: 600; color: var(--copy-ink); background: transparent; outline: none; transition: border-color .2s; }
              .robo-md-copywriter .preset-name-input:focus { border-bottom-color: var(--copy-accent); }
              .robo-md-copywriter .preset-name-input::placeholder { color: #9ca3af; font-weight: 500; }
              .robo-md-copywriter .lang-select-box { display: flex; flex-direction: column; gap: 8px; flex-shrink: 0; width: 140px; }
              .robo-md-copywriter .lang-select-box > div { min-width: 0; }
              .robo-md-copywriter .card { background: white; border: 1px solid var(--copy-border); border-radius: 12px; padding: 32px; box-shadow: 0 1px 3px rgba(0,0,0,.05); width: 100%; margin: 0; }
              .robo-md-copywriter .form-row { display: flex; align-items: flex-start; margin-bottom: 24px; gap: 24px; width: 100%; }
              .robo-md-copywriter .form-row:last-child { margin-bottom: 0; }
              .robo-md-copywriter .row-label { width: 140px; flex-shrink: 0; font-size: 15px; font-weight: 600; color: var(--copy-ink); display: flex; align-items: center; margin-top: 10px; }
              .robo-md-copywriter .row-content { flex: 1; min-width: 0; width: 100%; display: flex; flex-direction: column; gap: 8px; }
              .robo-md-copywriter textarea.form-control { width: 100%; padding: 12px 14px; border: 1px solid #d1d5db; border-radius: 6px; background: white; font-size: 14px; line-height: 1.5; color: var(--copy-ink); resize: vertical; min-height: 64px; transition: border-color .2s; }
              .robo-md-copywriter textarea.form-control:focus { outline: none; border-color: var(--copy-accent); box-shadow: 0 0 0 3px rgba(0,226,230,.1); }
              .robo-md-copywriter textarea.form-control::placeholder { color: #9ca3af; }
              .robo-md-copywriter .info-icon { display: inline-flex; align-items: center; justify-content: center; width: 18px; height: 18px; border-radius: 50%; background: #e5e7eb; color: #4b5563; font-size: 12px; font-weight: 700; margin-left: 6px; cursor: help; position: relative; flex-shrink: 0; }
              .robo-md-copywriter .info-icon:hover { background: #d1d5db; color: #111827; }
              .robo-md-copywriter .info-icon:hover::after { content: attr(data-tooltip); position: absolute; bottom: 130%; left: 50%; transform: translateX(-50%); background: #1f2937; color: white; padding: 8px 12px; border-radius: 6px; font-size: 12px; line-height: 1.4; white-space: normal; width: max-content; max-width: 250px; z-index: 1200; font-weight: 500; text-align: left; box-shadow: 0 4px 12px rgba(0,0,0,.15); }
              .robo-md-copywriter .tab-group { display: flex; gap: 8px; margin-bottom: 8px; flex-wrap: wrap; }
              .robo-md-copywriter .tab-btn { padding: 8px 16px; font-size: 13px; font-weight: 600; border: 1px solid #d1d5db; border-radius: 6px; background: white; color: #4b5563; cursor: pointer; transition: all .2s; }
              .robo-md-copywriter .tab-btn:hover { background: #f9fafb; }
              .robo-md-copywriter .tab-btn.active { background: rgba(0,226,230,.1); color: #111827; border-color: #00e2e6; }
              .robo-md-copywriter .multi-ref-grid { display: grid; grid-template-columns: 1fr; gap: 16px; width: 100%; }
              .robo-md-copywriter .multi-ref-card { background: white; border: 1px solid #d1d5db; border-radius: 8px; padding: 20px; transition: all .2s; position: relative; display: flex; flex-direction: column; min-width: 0; }
              .robo-md-copywriter .multi-ref-card.checked { border-color: var(--copy-accent); background: rgba(0,226,230,.02); }
              .robo-md-copywriter .ref-header { display: flex; align-items: center; gap: 10px; cursor: pointer; margin-bottom: 0; }
              .robo-md-copywriter .ref-header .common_checkbox { justify-content: flex-start; flex-shrink: 0; }
              .robo-md-copywriter .ref-header > label { flex: 1; min-width: 0; cursor: pointer; }
              .robo-md-copywriter .row-content > * { max-width: 100%; }
              .robo-md-copywriter .row-content input[type="text"] { max-width: 100%; }
              .robo-md-copywriter .ref-title { display: flex; align-items: center; font-weight: 600; font-size: 15px; color: var(--copy-ink); flex-wrap: wrap; min-width: 0; }
              .robo-md-copywriter .ref-inner { display: none; flex-direction: column; margin-top: 16px; flex: 1; min-width: 0; }
              .robo-md-copywriter .multi-ref-card.checked .ref-inner { display: flex; animation: copyFadeIn .3s ease; }
              .robo-md-copywriter .custom-box { background: #f9fafb; border: 1px dashed #d1d5db; border-radius: 6px; padding: 16px; margin-bottom: 12px; }
              .robo-md-copywriter .inner-item-grid { display: grid; grid-template-columns: 1fr; gap: 8px; }
              .robo-md-copywriter .inner-item { border: 1px solid #d1d5db; border-radius: 6px; padding: 16px 32px 16px 16px; cursor: pointer; background: white; position: relative; }
              .robo-md-copywriter .inner-item.selected { border-color: var(--copy-accent); box-shadow: 0 0 0 1px var(--copy-accent); background: rgba(0,226,230,.05); }
              .robo-md-copywriter .inner-item-text { font-size: 13px; color: var(--copy-ink); line-height: 1.6; white-space: pre-wrap; word-break: break-all; }
              .robo-md-copywriter .delete-btn { position: absolute; top: 10px; right: 10px; background: #f3f4f6; color: #6b7280; border: none; width: 24px; height: 24px; border-radius: 50%; display: flex; align-items: center; justify-content: center; cursor: pointer; font-size: 12px; font-weight: 700; }
              .robo-md-copywriter .delete-btn:hover { background: #fee2e2; color: #dc2626; }
              .robo-md-copywriter .secondary-title { margin-bottom: 16px; font-size: 15px; font-weight: 700; color: var(--copy-ink); }
              .robo-md-copywriter .secondary-note { margin: -8px 0 16px; color: var(--copy-muted); font-size: 13px; }
              .robo-md-copywriter .toggle-header { display: flex; justify-content: space-between; align-items: center; gap: 16px; width: 100%; padding: 16px; background: #f9fafb; border: 1px solid var(--copy-border); border-radius: 8px; cursor: pointer; text-align: left; }
              .robo-md-copywriter .toggle-header strong { font-size: 14px; font-weight: 700; display: block; color: var(--copy-ink); }
              .robo-md-copywriter .toggle-header small { display: block; color: var(--copy-muted); margin-top: 4px; font-size: 12px; }
              .robo-md-copywriter .toggle-switch { flex-shrink: 0; width: 46px; height: 25px; background: #d1d5db; border-radius: 20px; position: relative; transition: background .2s; }
              .robo-md-copywriter .toggle-switch.on { background: var(--copy-accent); }
              .robo-md-copywriter .toggle-knob { position: absolute; background: #fff; border-radius: 50%; width: 19px; height: 19px; top: 3px; left: 3px; box-shadow: 0 1px 4px rgba(0,0,0,.14); transition: left .2s; }
              .robo-md-copywriter .toggle-switch.on .toggle-knob { left: 24px; }
              .robo-md-copywriter .radio-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 12px; margin-top: 12px; }
              .robo-md-copywriter .radio-label { display: flex; flex-direction: column; gap: 8px; align-items: center; text-align: center; border: 1px solid #d1d5db; border-radius: 8px; padding: 16px 12px; background: #fff; cursor: pointer; }
              .robo-md-copywriter .radio-label.selected { border-color: var(--copy-accent); background: rgba(0,226,230,.03); }
              .robo-md-copywriter .radio-label input { accent-color: var(--copy-accent); }
              .robo-md-copywriter .radio-label strong { display: block; font-size: 13px; color: var(--copy-ink); }
              .robo-md-copywriter .radio-label small { display: block; font-size: 12px; color: var(--copy-muted); }
              .robo-md-copywriter .robomd-list { background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 6px; padding: 12px; max-height: 240px; overflow-y: auto; }
              .robo-md-copywriter .robomd-item { display: block; width: 100%; padding: 12px 16px; margin-bottom: 8px; background: #fff; border: 1px solid #e5e7eb; border-radius: 6px; text-align: left; cursor: pointer; white-space: pre-line; font-size: 13px; color: var(--copy-ink); line-height: 1.6; }
              .robo-md-copywriter .robomd-item:last-child { margin-bottom: 0; }
              .robo-md-copywriter .robomd-item.active { border-color: var(--copy-accent); box-shadow: 0 0 0 1px var(--copy-accent); background: rgba(0,226,230,.05); }
              .robo-md-copywriter #language_select, 
              .robo-md-copywriter #ig_account_select,
              .robo-md-copywriter #copywriter-edit-language_select,
              .robo-md-copywriter #copywriter-edit-ig_account_select {
                background-color: white; 
              }
              @keyframes copyFadeIn { from { opacity: 0; transform: translateY(-5px); } to { opacity: 1; transform: translateY(0); } }
              @media (max-width: 768px) {
                @supports (height: 100dvh) { #page-wrapper.robo-md-copywriter-setting-page { height: 100dvh !important; } }
                #page-wrapper.robo-md-copywriter-setting-page { padding: 60px 0 72px !important; }
                .robo-md-copywriter-setting-page.copywriter-edit-panel { height: min(840px, 100%); }
                .robo-md-copywriter .copywriter-page-header { padding: 16px; flex-direction: column; align-items: flex-start; gap: 16px; }
                .robo-md-copywriter .header-title-group { width: 100%; }
                .robo-md-copywriter .page-title { font-size: 18px; white-space: normal; }
                .robo-md-copywriter .header-actions { width: 100%; justify-content: flex-end; flex-wrap: wrap; gap: 8px; }
                .robo-md-copywriter .btn-header { padding: 8px 16px; min-height: 36px; font-size: 13px; }
                .robo-md-copywriter .automation-menu { right: 0; }
                .robo-md-copywriter .content-container { padding: 20px 16px; }
                .robo-md-copywriter .content-inner { gap: 20px; }
                .robo-md-copywriter .title-lang-row { flex-direction: column; align-items: flex-start; gap: 16px; }
                .robo-md-copywriter .title-group { width: 100%; }
                .robo-md-copywriter .lang-select-box { width: 100%; flex-direction: row; align-items: center; justify-content: space-between; }
                .robo-md-copywriter .lang-select-box > div { width: 150px; }
                .robo-md-copywriter .card { padding: 24px 16px; }
                .robo-md-copywriter .form-row { flex-direction: column; gap: 8px; margin-bottom: 24px; }
                .robo-md-copywriter .row-label { width: 100%; margin-top: 0; }
                .robo-md-copywriter .radio-grid { grid-template-columns: 1fr; }
              }
            `}</style>

            {!isEditingInModal && <div className="copywriter-page-header">
              <div className="header-title-group">
                <div className="header-accent-bar" />
                <div className="header-title-inline">
                  <h1 className="page-title">AI 카피라이터</h1>
                  <span
                    className="info-icon"
                    title="AI 문구를 자연스럽게 만들기 위해 필요한 정보와 문구 생성 명령을 저장하는 기능입니다."
                    data-tooltip="AI 문구를 자연스럽게 만들기 위해 필요한 정보와 문구 생성 명령을 저장하는 기능입니다."
                  >!</span>
                </div>
              </div>
              <div className="header-actions">
                <button
                  type="button"
                  className="btn-header btn-gray"
                  onClick={this.handleSaveAndRunPreset}
                  disabled={this.state.isSavingPreset}
                >문구만들기</button>
                <button
                  type="button"
                  className="btn-header btn-cyan"
                  onClick={this.handleSavePreset}
                  disabled={this.state.isSavingPreset}
                >저장</button>
              </div>
            </div>}

            <ContentContainer className="content-container">
              {isEditPresetLoading && <p role="status">카피라이터 설정을 불러오는 중입니다.</p>}
              {editPresetLoadError && <p role="alert">{editPresetLoadError}</p>}
              {isEditorReady &&
              <div className="content-inner">
                <div className="title-lang-row">
                  <div className="title-group">
                    <label htmlFor={formId('presetTitle')} className="title-label">설정 제목 <span className="req">*</span></label>
                    <input type="text" id={formId('presetTitle')} className="preset-name-input clear-placeholder"
                      data-placeholder={this.state.suggestedPresetTitle}
                      value={presetTitle || ''}
                      onChange={(e) => this.handleStateChange('presetTitle', e.target.value)}
                      onFocus={this.handleFocus} onBlur={this.handleBlur}
                      placeholder={this.state.suggestedPresetTitle} />
                  </div>
                  <div className="lang-select-box">
                    <label className="title-label" htmlFor={formId('language_select')}>생성 언어 <span className="req">*</span></label>
                    <SelectBoxV2 id={formId('language_select')} list={languageList}
                      optionTexttName="name" optionValuetName="code" selectedValue={language}
                      onClickOption={(text, value) => this.handleStateChange('language', value)}
                      pageWrapperName={wrapperId} width="100%" height="40px" />
                  </div>
                </div>

                <section className="card" data-instagram-tutorial="copy-setting-target">
                  <div className="form-row">
                    <label className="row-label" htmlFor={formId('industry')}>업종 특성 <span className="req">*</span></label>
                    <div className="row-content" >
                      <textarea id={formId('industry')} className="form-control" rows={1}
                        value={industry || ''}
                        onChange={(e) => this.handleStateChange('industry', e.target.value)}
                        placeholder="개인이나 서비스의 특성을 입력해주세요 (예: 커뮤니티를 위한 교육서비스 앱)" />
                    </div>
                  </div>
                  <div className="form-row">
                    <label className="row-label" htmlFor={formId('target')}>주요 고객 <span className="req">*</span></label>
                    <div className="row-content">
                      <textarea id={formId('target')} className="form-control" rows={1}
                        value={target || ''}
                        onChange={(e) => this.handleStateChange('target', e.target.value)}
                        placeholder="문구를 보게 될 고객의 특성을 입력해주세요" />
                    </div>
                  </div>
                  <div className="form-row">
                    <label className="row-label" htmlFor={formId('objective')}>생성 목적 <span className="req">*</span></label>
                    <div className="row-content">
                      <textarea className="form-control" id={formId('objective')} rows="1"
                        value={objective || ''} onChange={(e) => this.handleStateChange('objective', e.target.value)}
                        placeholder="정보 전달, 조회수 높이기, 일상 공유 등 글의 제작 방향을 적어주세요" />
                    </div>
                  </div>
                  <div className="form-row" data-instagram-tutorial="copy-setting-prompt">
                    <label className="row-label" htmlFor={formId('extraPrompt')}>
                      상세명령
                      <span className="info-icon" title="상세명령으로 문구가 생성됩니다. 필요한 정보와 지시사항을 입력해주세요." data-tooltip="상세명령으로 문구가 생성됩니다. 필요한 정보와 지시사항을 입력해주세요.">!</span>
                    </label>
                    <div className="row-content">
                      <textarea className="form-control" id={formId('extraPrompt')} rows="4"
                        value={extraPrompt || ''} onChange={(e) => this.handleStateChange('extraPrompt', e.target.value)}
                        placeholder="AI로 문구를 만들기 위한 정보와 지시사항을 입력해주세요" />
                    </div>
                  </div>
                  <div className="form-row" data-instagram-tutorial="copy-setting-cta">
                    <label className="row-label" htmlFor={formId('ctaText')}>
                      위치고정문구
                      <span className="info-icon" title="생성된 글의 상단이나 하단에 항상 들어갈 예약 링크, 인사말 등의 안내사항을 적어주세요. 선택사항입니다." data-tooltip="생성된 글의 상단이나 하단에 항상 들어갈 예약 링크, 인사말 등의 안내사항을 적어주세요. 선택사항입니다.">!</span>
                    </label>
                    <div className="row-content">
                      <div className="tab-group" role="group" aria-label="고정 문구 삽입 위치">
                        <button type="button" className={`tab-btn ${ctaPosition === 'bottom' ? 'active' : ''}`}
                          aria-pressed={ctaPosition === 'bottom'} onClick={() => this.handleStateChange('ctaPosition', 'bottom')}>문구 하단 고정</button>
                        <button type="button" className={`tab-btn ${ctaPosition === 'top' ? 'active' : ''}`}
                          aria-pressed={ctaPosition === 'top'} onClick={() => this.handleStateChange('ctaPosition', 'top')}>문구 상단 고정</button>
                      </div>
                      <textarea className="form-control" id={formId('ctaText')} rows="3"
                        value={ctaText || ''} onChange={(e) => this.handleStateChange('ctaText', e.target.value)}
                        placeholder="입력된 내용이 선택 위치에 그대로 들어갑니다 (예: 팔로우해주세요!)" />
                    </div>
                  </div>
                  <div className="form-row" data-instagram-tutorial="copy-setting-voice">
                    <div className="row-label" style={{ marginTop: '4px' }}>
                      말투따라하기
                      <span className="info-icon" title="별도의 말투를 선택하지 않아도 AI 기본 말투를 제공합니다. 체크한 말투를 AI가 참고합니다." data-tooltip="별도의 말투를 선택하지 않아도 AI 기본 말투를 제공합니다. 체크한 말투를 AI가 참고합니다.">!</span>
                    </div>
                    <div className="row-content">
                      <div className="multi-ref-grid">
                  {/* 내 기존 피드 AI 보이스 */}
                  <div className={`multi-ref-card ${cardsChecked['ref-myfeed'] ? 'checked' : ''}`} data-instagram-tutorial="copy-setting-voice-myfeed">
                    <div className="ref-header">
                      <CheckBox
                        id={formId('ref-myfeed')}
                        checked={cardsChecked['ref-myfeed']}
                        onChangeCheck={(e) => {
                          this.handleCardCheck('ref-myfeed', e.target.checked);

                          if (e.target.checked) {
                            const igSeq = this.getActiveIgSeq();
                            if (igSeq && (!this.state.feedCaptions || this.state.feedCaptions.length === 0)) {
                              this.fetchAllInstagramMedia(false, igSeq);
                            }
                          }
                        }}
                      />
                      <label htmlFor={formId('ref-myfeed')} style={{ flex: 1, cursor: 'pointer' }}>
                        <div className="ref-title">내 인스타그램 피드말투
                          <span className="info-icon" title="내가 기존에 썼던 게시글의 말투를 선택하면 AI가 유사하게 따라합니다." data-tooltip="내가 기존에 썼던 게시글의 말투를 선택하면 AI가 유사하게 따라합니다.">!</span>
                        </div>
                      </label>
                    </div>

                    <div className="ref-inner" data-instagram-tutorial="copy-setting-voice-myfeed-detail">
                      {this.state.accountConnected ? (
                        <div>
                          <div style={{ marginBottom: 16 }}>
                            <label className="form-label" style={{ marginBottom: 8, display: "block" }}>
                              인스타그램 계정 선택
                            </label>
                            <SelectBoxV2
                              id={formId('ig_account_select')}
                              className="background-white"
                              tabIndex={0}
                              width="100%"
                              height="40px"
                              padding="8px 36px 8px 12px"
                              backgroundColor="#fff"
                              pageWrapperName={isEditingInModal ? wrapperId : 'common-page-wrapper'}
                              list={this.state.account_list || []}
                              optionTexttName="title"
                              optionValuetName="value"
                              selectedValue={this.getActiveIgSeq()}
                              onClickOption={this.onChangeAccount}
                            />
                          </div>

                          <div style={{ marginBottom: 8 }}>
                            <span style={{ fontSize: 15, fontWeight: 700, color: "#0A1A2F" }}>
                              학습 기준이 될 최근 게시물을 하나 선택해주세요.
                            </span>
                            {/* <span style={{ fontSize: 12, color: "#6b7280", marginLeft: 8 }}>
                              (선택한 개수: {this.state.selectedLearnedFeedCaptions?.length || 0}개)
                            </span> */}
                          </div>

                          <div
                            className="robomd-list"
                            style={{
                              marginTop: 0,
                              maxHeight: 240,
                              overflowY: "auto",
                              border: "1px solid #e5e7eb",
                              borderRadius: 6,
                              padding: 12,
                              backgroundColor: "#f9fafb",
                            }}
                          >
                            {this.state.feedCaptions && this.state.feedCaptions.length > 0 ? (
                              this.state.feedCaptions.map((obj) => (
                                <button
                                  key={obj.instagram_media_id}
                                  type="button"
                                  className={`robomd-item ${
                                    this.state.selectedLearnedFeedCaptions.some(
                                      (item) => item.instagram_media_id == obj.instagram_media_id
                                    )
                                      ? "active"
                                      : ""
                                  }`}
                                  // onClick={() => this.selectLearnedFeed(obj.instagram_media_id, obj.caption)}
                                  onClick={() => this.selectLearnedFeedOnlyOne(obj.instagram_media_id, obj.caption)}
                                >
                                  <div style={{fontSize: "14px",
                                    fontWeight: 700,
                                    // marginBottom: '8px'
                                  }}>{obj.caption}</div>
                                  {/* <span style={{
                                    fontSize: '12px',          
                                    fontWeight: 600,          
                                    background: '#f1f5f9',
                                    color: '#475569',
                                    padding: '4px 8px',
                                    borderRadius: '6px',       
                                  }}>
                                    {this.formatDate(obj.timestamp)}
                                  </span> */}
                                </button>
                              ))
                            ) : (
                              <div style={{ fontSize: 14, color: "#6b7280" }}>
                                불러온 피드 문구가 없습니다.
                              </div>
                            )}
                          </div>

                          <p style={{ fontSize: 12, color: "#6b7280", marginTop: 8, lineHeight: "1.6" }}>
                            {/* 선택한 피드 문구를 기반으로 AI가 말투와 감성을 참고합니다. */}
                            선택한 피드 문구를 분석하여 내 피드와 어울리는 문구를 작성합니다.
                          </p>
                        </div>
                      ) : (
                        <div
                          style={{
                            textAlign: 'center',
                            padding: '40px 20px',
                            background: 'white',
                            borderRadius: '8px',
                            border: '1px dashed #d1d5db'
                          }}
                        >
                          <div style={{ fontSize: '32px', marginBottom: '12px' }}>📱</div>
                          <p style={{ fontSize: '16px', fontWeight: '600', color: '#0A1A2F', marginBottom: '8px' }}>
                            인스타그램 계정이 연동되지 않았습니다.
                          </p>
                          <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '20px', lineHeight: '1.6' }}>
                            계정을 연동하면 반응이 좋았던 내 게시글을 AI가 학습합니다.<br />
                            <strong>자주 쓰는 단어, 이모지 패턴, 특유의 감성</strong>까지<br />
                            분석하여 내 피드와 어울리는 문구를 작성합니다.
                          </p>
                          <button
                            className="btn btn-primary"
                            style={{ padding: '12px 24px', fontSize: '14px' }}
                            onClick={this.handleConnectAccount}
                          >
                            인스타그램 계정 연동하기
                          </button>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* 커스텀 뱅크 AI 보이스 */}
                  <div className={`multi-ref-card ${cardsChecked['ref-custom'] ? 'checked' : ''}`} data-instagram-tutorial="copy-setting-voice-custom">
                    <div className="ref-header">
                      <CheckBox 
                        id={formId('ref-custom')}
                        checked={cardsChecked['ref-custom']}
                        onChangeCheck={(e) => this.handleCardCheck('ref-custom', e.target.checked)}
                      />
                      <label htmlFor={formId('ref-custom')} style={{ flex: 1, cursor: 'pointer' }}>
                        <div className="ref-title">따라할 말투
                          <span className="info-icon" title="따라하고 싶은 문구를 저장하면 AI가 그 문구의 말투를 유사하게 따라합니다." data-tooltip="따라하고 싶은 문구를 저장하면 AI가 그 문구의 말투를 유사하게 따라합니다.">!</span>
                        </div>
                      </label>
                    </div>
                    <div className="ref-inner" data-instagram-tutorial="copy-setting-voice-custom-detail">
                      <div style={{ background: '#f9fafb', border: '1px dashed #d1d5db', borderRadius: '8px', padding: '20px', marginBottom: '24px' }}>
                        <textarea 
                          id={formId('customText')}
                          className="form-control" 
                          rows="3" 
                          placeholder="따라하고 싶은 피드 문구를 여기에 복사해 넣으세요." 
                          style={{ fontSize: '13px', padding: '12px' }}
                          value={customTextInput || ''}
                          onChange={(e) => this.handleStateChange('customTextInput', e.target.value)}
                        ></textarea>
                        <div style={{ textAlign: 'right', marginTop: '12px' }}>
                          <button className="btn btn-outline" style={{ padding: '6px 16px', fontSize: '12px' }} onClick={this.handleAddCustomRef}>+ 뱅크에 추가</button>
                        </div>
                      </div>
                      <div className="inner-item-grid" id={formId('custom-grid')}>
                        {customItems.map((item, idx) => (
                          <div key={item.custom_reference_seq || idx} className={`inner-item ${selectedInnerItems['ref-custom'] === idx ? 'selected' : ''}`} onClick={() => this.handleInnerItemSelect('ref-custom', idx)}>
                            <button className="delete-btn" onClick={(e) => this.handleDeleteCustomRef(e, idx)}>✕</button>
                            <div className="inner-item-text">{item.custom_reference_text}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                      </div>
                    </div>
                  </div>
                </section>

                {/* AI 브랜드 보이스 및 멀티모달 데이터 학습 설정은 기본 적용하며 화면에서 숨김.
                    저장 시에도 use_basic_voice=1, is_data_learning_on=1, learning_data_type=multi. */}
              </div>}
            </ContentContainer>
            {isEditingInModal && (
              <div className="copywriter-edit-footer">
                {editorMessage && <p className="copywriter-edit-error" role="alert">{editorMessage}</p>}
                <button type="button" className="btn-header btn-outline" disabled={isSavingPreset}
                  onClick={this.props.onCancelEdit}
                >취소</button>
                <button type="button" className="btn-header btn-cyan"
                  disabled={!isEditorReady || isEditAccountLoading || isSavingPreset}
                  onClick={this.handleSavePreset}
                >{isSavingPreset ? '저장 중...' : '저장'}</button>
              </div>
            )}
          </div>
        </div>

        {!isEditingInModal && <RoboMDAICopywriterModal
          key={`copywriter-run-${this.state.runModalKey}`}
          isOpen={this.state.isRunModalOpen}
          onClose={this.closeRunModal}
          presetMode="FIXED"
          fixedPresetSeq={this.state.runPresetSeq || this.state.preset_seq}
          historyEnabled={false}
          onContentRegister={this.handleSelectedContentRegister}
          contentRegisterButtonLabel="선택 문구로 콘텐츠 등록하러 가기"
        />}
        {!isEditingInModal && this.state.save_dialog_show_state === true &&
          <SaveDialogV2 content={this.state.save_dialog_content} button_list={this.state.save_dialog_button_list} />
        }
        {!isEditingInModal && this.state.warning_dialog_show_state === true &&
          <WarningDialog content={this.state.warning_dialog_content} button_list={this.state.warning_dialog_button_list} />
        }
      </>
    );
    return isEditingInModal
      ? createPortal(<div className="copywriter-edit-overlay">{content}</div>, document.body)
      : content;
  }
}

export default InstagramCopywriterSetting;
